export const initialValues = {
  userDocumentInfo: [],
  applicantInformation: {
    fullName: "",
    contactEmail: "",
  },
  application: {
    name: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    homePhone: "",
    workPhone: "",
    otherPhone: "",
    dob: "",
    lastFourSocial: "",
    gender: "",
    maritalStatus: "",
    disabled: "",
    cityEmployee: "",
    races: "",
    incomeSources: {
      wages: "",
      pension: "",
      publicAssistance: "",
      ssi: "",
      other: "",
    },
  },
  householdIncome: [],
  propertyInformation: {
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    housePrice: "",
    buyersAgentName: "",
    buyersWorkPhone: "",
    buyersAgentEmail: "",
    sellersName: "",
    sellersAgentName: "",
    sellersWorkPhone: "",
    sellersAgentEmail: "",
  },
  attachments: {
    approvalLetter: {
      selectedFiles: [],
    },
    taxReturn: {
      selectedFiles: [],
    },
    payStubs: {
      selectedFiles: [],
    },
    bankStatements: {
      selectedFiles: [],
    },
  },
};
